module.exports = __webpack_public_path__ + "img/gender_equity.5245ed81.png";